import { usePunditUserContext } from "@/react/contexts";

export const useIsCustomThemesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.builder_custom_themes_enabled);
};
